export default "__VITE_ASSET__J8ED2LNr__"